import { render, staticRenderFns } from "./SpellCheckFieldsPopup.vue?vue&type=template&id=b6f03060&scoped=true&"
import script from "./SpellCheckFieldsPopup.vue?vue&type=script&lang=js&"
export * from "./SpellCheckFieldsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f03060",
  null
  
)

export default component.exports